import { useFormik } from "formik";
import * as Yup from "yup";
import { setBreadCrumb } from "middleware/actions/breadCrumbAction";
import { setProductImage } from "middleware/actions/productAction";
import { addProductBasic, editProductBasic, fetchProductImageUrl } from "middleware/services/productApi";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { accessRightActionCheck, getProductVariant } from "utilities";
import { productValidationSchema } from "app/helper/validationSchema/productValidationSchema";
import { COMMON_ACCESS_ACTION } from "constants";
import { TextField, Dropdown } from "../../../../../../../components/CustomFormElements/syncFusionFormFields";
import { ckEditorMinimalConfig } from "../../../../../../../../config/ckEditorConfig";
import productImage from "../../../../../../../../assets/images/product.jpg";
import { PRODUCT_LOGO_IMG_SIZE } from "config";
import { actionError, actionSuccess, hideLoader, showLoader } from "middleware/actions/utilityAction";
import { fetchSingleCompany } from "middleware/services/companyApi";
import PropTypes from "prop-types";
import { CkEditorVideo } from "app/components/CustomFormElements/ProductInformation";

const ProductDetails = (props) => {
  const { companyId, productId } = props.computedMatch?.params;
  const dispatch = useDispatch();
  const { accessRights: aR, editData } = props;
  const history = useHistory();
  const [productProfileImage, setProductProfileImage] = useState(undefined);
  const [imageError, setImageError] = useState("");
  const [interfaceActionAccessOverview, setInterfaceActionAccessOverview] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [productName, setProductName] = useState("");

  const split_url = props?.location?.pathname.split("/");
  let backPath = editData ? `${split_url.slice(0, -2).join("/")}/edit#overview` : `${split_url.slice(0, -2).join("/")}/add#overview`;
  const productVariant = getProductVariant();
  const { productDetails, productImage: productImg, valuePreposition: valuePrepositionDetails } = useSelector((state) => state.productState || {});

  const breadCrumbLinks = useMemo(() => {
    const links = [{ linkUrl: "/company", linkName: `Company`, linkActive: false }];

    if (companyId && companyName) {
      links.push({ linkUrl: `/company/${companyId}/edit#basic`, linkName: companyName, linkActive: false });
      links.push({ linkUrl: `/company/${companyId}/edit#basic`, linkName: aR.moduleName, linkActive: false });
    }
    if (!editData) {
      links.push({
        linkUrl: `/company/${companyId}/product/add#overview`,
        linkName: "Add New",
        linkActive: false,
      });
      links.push({
        linkUrl: `/company/${companyId}/product/add#overview`,
        linkName: "Product Details & Description",
        linkActive: false,
      });
      links.push({ linkUrl: ``, linkName: "Add New", linkActive: true });
    } else if (editData && productId && productName) {
      links.push({
        linkUrl: `/company/${companyId}/product/${productId}/edit#overview`,
        linkName: productName,
        linkActive: false,
      });
      links.push({
        linkUrl: `/company/${companyId}/product/${productId}/edit#overview`,
        linkName: "Product Details & Description",
        linkActive: false,
      });
      links.push({ linkUrl: ``, linkName: "Edit", linkActive: true });
    }

    return links;
  }, [companyId, companyName, aR.moduleName, productId, productName]);

  const productInformation = {
    productName: "",
    yearLaunched: "",
    licencingAvailablity: "",
    techMaturityLevel: "",
    domainClassification: "",
    productSourceURL: "",
    productDescription: "",
    productWhatsUnique: "",
    productProfileImage: "",
    productPaywallSetting: "NO",
  };
  const formik = useFormik({
    initialValues: {
      ...productInformation,
    },
    validationSchema: Yup.object().shape(productValidationSchema),
  });

useEffect(() => {
  if (formik.values?.productName) {
    formik.setTouched({ ...formik.touched, productName: true });
  }
}, [formik.values.productName]);

  const productProfileImageRef = useRef(null);
  const productProfileImageInputRef = useRef(null);

  const getCompanyName = async () => {
    let fields = { fields: ["id", "companyName"] };
    if (companyId) {
      if (Object.keys(productDetails).length > 0) {
        setCompanyName(productDetails.productCompany.companyName);
      } else {
        try {
          const response = await fetchSingleCompany(companyId, { ...fields });
          setCompanyName(response.data.data.companyName);
        } catch (error) {
          dispatch(actionError(error.data.message || "something went wrong."));
        }
      }
    }
  };

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = "Overview";
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccessOverview(actionAccess);
  }, []);

  const readProductProfileImage = (imageFile) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      let productImage = {
        productImgFile: imageFile,
        productImg: e.target.result,
      };
      dispatch(setProductImage(productImage));
      productProfileImageRef.current.setAttribute("src", e.target.result);
    };

    reader.readAsDataURL(imageFile);
  };

  const fetchProductImage = () => {
    // if (productImg.productImg?.length > 1) {
    //   return productImg.productImg;
    // } else {
    // }
    return fetchProductImageUrl(formik.values?.productProfileImage);
  };

  const setFormikValues = async (response) => {
    let result = { ...response };
    // if (Object.keys(productDetails).length > 0) {
    //   if (productImg != "") {
    //     result.productProfileImage = productImg.productImg;
    //     result.productImage = productImg.productImgFile;
    //   }
    // }

    const oldData = {
      productName: result.productName ? result.productName : "",
      yearLaunched: result.yearLaunched ? result.yearLaunched : result.productLaunchYear || "",
      licencingAvailablity: result.licencingAvailablity ? result.licencingAvailablity : result.productLicensingAvailability || "",
      techMaturityLevel: result.techMaturityLevel ? result.techMaturityLevel : result.productTechnologyMaturityLevel || "",
      domainClassification: result.domainClassification ? result.domainClassification : result.productDomainClassification || "",
      productSourceURL: result.productSourceURL ? result.productSourceURL : result.productUrl || "",
      productDescription: result.productDescription || "",
      productWhatsUnique: result.productWhatsUnique ? result.productWhatsUnique : "",
      productProfileImage: result.productProfileImage || "",
      productPaywallSetting: result?.productPaywallSetting?.length > 0 ? result?.productPaywallSetting : "NO",
      productImage: result?.productImage ? result.productImage : "",
    };

    formik.setValues(oldData);
  };

  useEffect(() => {
    if (editData && Object.keys(productDetails || {}).length > 0) {
        setFormikValues(productDetails);
        setProductName(productDetails.productName);
    } else {
      formik.resetForm();
    }
    getCompanyName();
  }, [editData, props.location?.state, productDetails]);

  const handleSubmit = () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).forEach((field) => {
          touched[field] = true;
        });
        res["productProfileImage"] ? setImageError("Please upload image.") : setImageError("");
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        if (imageError) {
          dispatch(actionError(imageError));
        } else {
          saveProductData();
        }
      }
    });
  };

  const saveProductData = async () => {
    const { values } = formik;
    let productPaywallProductPlatform = productVariant == "Cognition" ? "Signal V2" : `${productVariant} V2`;
    let productPaywallSettingData =
      formik.values?.productPaywallSetting == "YES"
        ? JSON.stringify([
            {
              productVariant: productVariant,
              productPlatform: productPaywallProductPlatform,
              taxonomyTagging: [],
            },
          ])
        : JSON.stringify([]);
    const productData = {
      companyId: props.computedMatch.params?.companyId !== undefined ? props.computedMatch.params?.companyId : "",
      productName: values.productName.trim(),
      productLaunchYear: values.yearLaunched,
      productLicensingAvailability: values.licencingAvailablity.trim(),
      productTechnologyMaturityLevel: values.techMaturityLevel,
      productDomainClassification: values.domainClassification.trim(),
      productUrl: values.productSourceURL.trim(),
      productDescription: values.productDescription,
      productWhatsUnique: values.productWhatsUnique !== undefined ? values.productWhatsUnique : "",
      productProfileImage: values.productProfileImage,
      productPaywallSetting: productPaywallSettingData,
    };
    if (Object.keys(valuePrepositionDetails).length > 0) {
      productData.productValuePropositionTime = valuePrepositionDetails.timeReduction;
      productData.productValuePropositionCost = valuePrepositionDetails.costReduction;
      productData.productValuePropositionProductivity = valuePrepositionDetails.increasesProductivity;
      productData.productValuePropositionEfficiency = valuePrepositionDetails.increasesEficiency;
      productData.productValuePropositionGeneration = valuePrepositionDetails.revenueGenration;
      productData.productValuePropositionBenefits = valuePrepositionDetails.technicalBenefits;
      productData.productValuePropositionAesthetics = valuePrepositionDetails.enhancesAesthetics;
    }
    if (values.productImage) productData.productProfileImage = values.productImage;
    if (editData) {
      delete productData.companyId;
      productData.id = productId;
    }
    editData ? onUpdateData(productData) : onSaveData(productData);
  };

  const onUpdateData = async (data) => {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    try {
      dispatch(showLoader());
      await editProductBasic(data.id, formData);
      dispatch(hideLoader());
      dispatch(actionSuccess("Product updated successfully"));
      history.push(backPath, { shouldRefresh: true });
    } catch (err) {
      dispatch(actionError(err ? err?.data?.message : "SOMETHING WENT WRONG."));
    } finally {
      dispatch(hideLoader());
    }
  };

  const onSaveData = async (data) => {
    try {
      const formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      if (productVariant) formData.append("productVariant", JSON.stringify([{ productName: productVariant, isLive: "NO" }]));
      dispatch(showLoader());
      const response = await addProductBasic(formData);
      dispatch(hideLoader());
      dispatch(actionSuccess("Product added successfully"));
      backPath = `${split_url.slice(0, -2).join("/")}/${response?.data?.data?.id}/edit#overview`;
      history.push(backPath, { shouldRefresh: true });
    } catch (err) {
      dispatch(actionError(err ? err?.data?.message : "SOMETHING WENT WRONG."));
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));

    return () => {
      dispatch(setBreadCrumb([]));
    };
  }, [dispatch, breadCrumbLinks]);

  const accessActionSave = interfaceActionAccessOverview.includes(COMMON_ACCESS_ACTION.SAVE);
  
  return (
    <div className="gennx-content-wrapper padding-bottom-100i overflow-hidden">
      <div className="mx-3 border border-black d-flex flex-column custom-container">
        <div style={{ overflowY: "auto", flexGrow: 1, padding: "1rem" }}>
          <form className="d-flex flex-column">
            <div className="row px-3">
              <div className="col-md-12 p-2 border custom-bg-grey text-white rounded-top">Product Detail &amp; Logo</div>
              <div className="col-md-12 border rounded-bottom px-3 pt-3">
                <div className="col">
                  <div className="row mb-3" style={{ fontSize: "16px", fontWeight: 700, color: "#4B4B55" }}>
                    Upload Product Image *
                  </div>
                  <div className="mb-4">
                    <div className="row">
                      <div className="product-logo-holder p-0">
                        <div>
                          <img
                            src={formik.values.productProfileImage ? fetchProductImage() : productImage}
                            alt="Product"
                            ref={productProfileImageRef}
                            className="object-cover"
                          />
                        </div>
                        <div className="product-logo-action" style={{ top: "2px", right: "6px" }}>
                          <span onClick={() => productProfileImageInputRef.current.click()}>
                            <i className="fa fa-pencil-alt" aria-hidden="true"></i>
                          </span>
                        </div>
                        <input
                          type="file"
                          className="d-none"
                          accept=".jpg, .jpeg, .png"
                          id="productProfileImage"
                          name="productProfileImage"
                          ref={productProfileImageInputRef}
                          onChange={(e) => {
                            if (e.target.files.length > 0) {
                              if (
                                (e.target.files[0].type == "image/png" ||
                                  e.target.files[0].type == "image/jpg" ||
                                  e.target.files[0].type == "image/jpeg") &&
                                e.target.files[0].size < PRODUCT_LOGO_IMG_SIZE
                              ) {
                                setImageError("");
                                setProductProfileImage(e.target.files[0].name);
                                readProductProfileImage(e.target.files[0]);

                                if (productProfileImageInputRef.current.files.length)
                                  formik.setValues({
                                    ...formik.values,
                                    productProfileImage: productProfileImageInputRef.current.files[0],
                                  });
                              } else {
                                setProductProfileImage("");
                                setImageError("File must be JPG/JPEG or PNG format and size must not exceed 10 MB.");
                              }
                            } else {
                              setImageError("Please upload image.");
                            }
                          }}
                        />
                      </div>
                      <div className="ml-3">
                        <p className="mb-0">Note:</p>
                        <ul className="ml-4">
                          <li>Only JPG/JPEG or PNG files are allowed.</li>
                          <li>Max file size allowed is 10MB.</li>
                          <li>Thumbnail Dimensions: 350W x 200H</li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="d-flex align-item-center justify-content-start text-danger"
                      style={{ display: imageError ? "block" : "none", marginLeft: "-1rem" }}
                      role="alert"
                    >
                      <small>{imageError}</small>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 pl-0">
                      <TextField formik={formik} id="productName" name="productName" placeholder="Product Name *" required="required" />
                    </div>
                    <div className="col-md-4">
                      <TextField type="number" formik={formik} id="yearLaunched" name="yearLaunched" placeholder="Year Launched" />
                    </div>
                    <div className="col-md-4 pr-0">
                      <TextField formik={formik} id="licencingAvailablity" name="licencingAvailablity" placeholder="Licensing Availability" />
                    </div>
                    <div className="col-md-4 pl-0">
                      <Dropdown
                        formik={formik}
                        id="techMaturityLevel"
                        name="techMaturityLevel"
                        placeholder="Technology Maturity Level"
                        value={formik.values?.techMaturityLevel || productDetails?.techMaturityLevel}
                        change={(e) => formik.setFieldValue("techMaturityLevel", e.value)}
                        dataSource={[
                          "Concept Stage - Basic technology observed and reported",
                          "Concept Stage - Technology concept, product concept, and/or application formulated, feasibility quantified",
                          "Research Stage - Analytical and/or experimental proof of concept",
                          "Research Stage - Element validation of concepts for up-scaling in laboratory environment",
                          "Research Stage - Component validation in the relevant environment",
                          "Prototype Stage - Prototype demonstration in the relevant environment",
                          "Prototype Stage - System prototype demonstration in an operational environment",
                          "Prototype Stage - Actual system completed and 'qualified' through test and demonstration",
                          "Prototype Stage - Actual system 'proven' through successful mission operations",
                          "Commercialised",
                          "Widespread Adoption",
                        ]}
                        filtering={true}
                        // fields={{ text: "label", value: "value" }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextField formik={formik} id="domainClassification" name="domainClassification" placeholder="Domain/Classification" />
                    </div>
                    <div className="col-md-4 pr-0">
                      <TextField formik={formik} id="productSourceURL" name="productSourceURL" placeholder="Product Source URL" />
                    </div>
                  </div>
                </div>
              </div>

              {/* <label style={{ top: "20px", position: "relative" }}>About the Product</label> */}
              <div className="col-md-12 p-2 border custom-bg-grey text-white rounded-top mt-sm-3 ">About the Product *</div>
              <div className="col-md-12 border rounded-bottom">
                <div className="row">
                  <div className="col-lg-12 pt-3">
                    <CkEditorVideo
                      formik={formik}
                      properties={{
                        id: "productDescription",
                        name: "productDescription",
                        activeClass: "productDescription",
                        label: "About the Product *",
                        config: ckEditorMinimalConfig,
                        charCountLimit: 5000,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 p-2 border custom-bg-grey text-white rounded-top mt-sm-3">What is Unique about the Product?</div>
              <div className="col-md-12 border rounded-bottom">
                <div className="row">
                  <div className="col-lg-12 pt-3">
                    <CkEditorVideo
                      formik={formik}
                      properties={{
                        id: "productWhatsUnique",
                        name: "productWhatsUnique",
                        activeClass: "productWhatsUnique",
                        label: "What is Unique about the Product?",
                        config: ckEditorMinimalConfig,
                        charCountLimit: 5000,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="text-right border-top" style={{ padding: ".8rem" }}>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              formik.resetForm();
              history.push(backPath);
            }}
            className="btn btn-outline-dark mr-3 company-button"
          >
            Cancel
          </button>

          {accessActionSave ? (
            <button type="button" className="btn btn-primary company-button" onClick={handleSubmit} disabled={false}>
              {editData ? "Update" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;

ProductDetails.propTypes = {
  accessRights: PropTypes.object,
  location: PropTypes.object,
  computedMatch: PropTypes.object,
  editData: PropTypes.bool,
};
